import React from 'react';

import { injectIntl } from 'react-intl';
import { get } from 'lodash';

import { string, node, object } from 'prop-types';
import { MessageBubble } from '@landtrustinc/design-system';
import { formatDate } from '../../util/dates';
import {
  TRANSACTION_MESSAGE_SOURCE_SMS,
  TRANSACTION_MESSAGE_SOURCE_TWILIO,
} from '../../util/transaction';

const InboxMessage = ({ children, date, user, intl, direction, source }) => {
  const todayString = intl.formatMessage({ id: 'BookingStatus.today' });
  const userName = get(user, 'attributes.profile.displayName', '');
  const avatarSrc = get(user, 'profileImage.attributes.variants.square-small.url', null);

  const variant = direction === 'right' ? 'sent' : 'received';

  const timestamp = `${formatDate(intl, todayString, date)}${
    source && [TRANSACTION_MESSAGE_SOURCE_TWILIO, TRANSACTION_MESSAGE_SOURCE_SMS].includes(source)
      ? ' • Sent via SMS'
      : ''
  }`;

  return (
    <MessageBubble variant={variant} author={userName} timestamp={timestamp} avatarSrc={avatarSrc}>
      {children}
    </MessageBubble>
  );
};

InboxMessage.defaultProps = {
  direction: 'left',
  user: null,
  source: null,
};

InboxMessage.propTypes = {
  direction: string,
  children: node.isRequired,
  user: object,
  source: string,
};

export default injectIntl(InboxMessage);
